// extracted by mini-css-extract-plugin
export default {"main":"Description_main__Trwet"};